module.exports = __webpack_public_path__ + "img/hz_1.9ba13f07.jpg";